/**
 * True when a single filter entry is a real value (not null / blank string).
 * @param {*} value
 * @returns {boolean}
 */
export const isMeaningfulFilterValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  return true;
};

/**
 * Drop empty/placeholder entries from a filter list.
 * @param {*} raw
 * @returns {Array}
 */
export const meaningfulFilterList = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw.filter(isMeaningfulFilterValue);
};

/**
 * True when filterList has at least one real value (not null / '' placeholders).
 * @param {*} raw
 * @returns {boolean}
 */
export const hasMeaningfulFilterList = (raw) =>
  Array.isArray(raw) && raw.some(isMeaningfulFilterValue);

/**
 * Returns true when the filter map has at least one meaningful value.
 * Empty arrays (e.g. cleared checkboxes) and "-obj" companion keys do not count.
 *
 * @param {*} filters - Applied filter map, "All", or empty
 * @returns {boolean}
 */
export const hasActiveFilterValues = (filters) => {
  if (!filters || filters === "All" || typeof filters !== "object") return false;
  return Object.keys(filters).some((key) => {
    if (!key || key.endsWith("-obj")) return false;
    const raw = filters[key];
    if (!Array.isArray(raw)) return Boolean(raw);
    return hasMeaningfulFilterList(raw);
  });
};
